<mat-toolbar style="background-color: #03a9f4;height: 50px;">
  <h1 mat-dialog-title style="color: white">New User</h1>
  <button (click)="onNoClick()" style="margin-left: auto;">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<div mat-dialog-content>
  <div fxFlex fxLayout="row" fxLayoutAlign="center center" style="width:400px;">
    <form class="userForm" name="userForm" [formGroup]="userForm" novalidate (ngSubmit)="Save()">
      <div>
        <br>
        <div fxLayout="row" fxLayoutAlign="center" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex>
            <mat-form-field class="example-full-width">
              <input matInput matTooltip="Enter the  Email" placeholder="Email" formControlName="email" name="email">
              <mat-error>
                <eguard-validation-messages [control]='userForm.controls.email'></eguard-validation-messages>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex>
            <mat-form-field class="example-full-width">
              <input matInput matTooltip="First Name" placeholder="First Name" formControlName="first_name"
                name="first_name">
              <mat-error>
                <eguard-validation-messages [control]='userForm.controls.first_name'></eguard-validation-messages>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex>
            <mat-form-field class="example-full-width">
              <input matInput matTooltip="Last Name" placeholder="Last Name" formControlName="last_name"
                name="last_name">
              <mat-error>
                <eguard-validation-messages [control]='userForm.controls.last_name'></eguard-validation-messages>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex>
            <mat-form-field class="example-full-width">
              <input matInput matTooltip="Middle Name" placeholder="Middle Name" formControlName="middle_name"
                name="middle_name">
            </mat-form-field>
            <!-- <mat-error>
              <eguard-validation-messages [control]='userForm.controls.middle_name'></eguard-validation-messages>
            </mat-error> -->
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex>
            <mat-form-field class="example-full-width">
              <mat-select placeholder="Select a Role" class="example-full-width" formControlName="role" name="role">
                <mat-option value="CLERK">Clerk</mat-option>
                <mat-option value="PETITIONER">Petitioner</mat-option>
                <mat-option value="ATTORNEY">Attorney</mat-option>
                <mat-option value="APPRAISER">Appraiser</mat-option>
                <mat-option value="JUDGE">Judge</mat-option>
                <mat-option value="ASSESSOR">Assessor</mat-option>
                <mat-option value="HEIR">Heir</mat-option>
                <mat-option value="GUARDIAN">Guardian</mat-option>
                <mat-option value="GUARDIANADLITEM">Guardian Adlitem</mat-option>
              </mat-select>
              <mat-error>
                <eguard-validation-messages [control]='userForm.controls.role'></eguard-validation-messages>
              </mat-error>
            </mat-form-field>


          </div>
        </div>


      </div>
      <div mat-dialog-actions>
        <div fxFlex fxLayout="row" fxLayoutAlign="end center">
          <!-- <button mat-raised-button color="warn" (click)="onNoClick()" [disabled]="loading">Cancel</button> -->
          <button mat-raised-button color="accent" [class.loading]="loading" [disabled]="userForm.invalid || loading">
            <div class="spinner"></div>
            <span class="label">SUBMIT</span>
          </button>
        </div>
      </div>
      <br>
      <br>
    </form>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/userfrom/clerk-userform.component.html